import React, { useState } from 'react';
import axios from 'axios';
import { RotateCcw, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle, AlertDialogTrigger,
} from '../../../components/ui/alert-dialog';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/admin/demo-showcase`;

export const ResetDemoButton = ({ onDone }) => {
  const [busy, setBusy] = useState(false);
  const reset = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/reset`);
      toast.success(`Hear All reset — ${r.data.patients} patients, ${r.data.records} records loaded`);
      onDone?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Reset failed');
    } finally {
      setBusy(false);
    }
  };
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <button type="button" className="sc-btn sc-btn-ghost" disabled={busy} data-testid="showcase-reset-btn">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <RotateCcw size={16} />}
          {busy ? 'Resetting…' : 'Reset Hear All demo'}
        </button>
      </AlertDialogTrigger>
      <AlertDialogContent data-testid="showcase-reset-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Reset the Hear All demo clinic?</AlertDialogTitle>
          <AlertDialogDescription>
            Everything inside Hear All (and Hear All — Mysuru) is wiped and reloaded with fresh demo data dated to today.
            No other clinic is touched. Demo logins keep the same password.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="showcase-reset-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={reset} data-testid="showcase-reset-confirm">Reset demo data</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
